import React, { useState } from "react";
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, Button, Input, Select, Text, useToast } from "@chakra-ui/react";
import axios from "axios";

const AddMissingStoreModal = ({ isOpen, onClose, storeData, regions, refreshData }) => {
  const [region, setRegion] = useState("");
  const toast = useToast();

  const handleSave = async () => {
    if (!region) {
      toast({ title: "Region required", description: "Please select a region.", status: "warning", duration: 3000, isClosable: true });
      return;
    }

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/validation/ins-missing-store`, {
        site_code: storeData.site_code,
        site_description: storeData.site_description,
        region,
        retailer: storeData.retailer,
      });
      setRegion("");
      toast({ title: "Store added", description: `${storeData.site_code} added to store_details.`, status: "success", duration: 3000, isClosable: true });
      onClose();
      refreshData();
    } catch (error) {
      toast({ title: "Failed to add store", description: error?.response?.data?.message || "An error occurred.", status: "error", duration: 3000, isClosable: true });
    }
  };

  const handleClose = () => {
    setRegion("");
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add Missing Store</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text fontSize="sm" color="gray.500" mb={1}>Site Code</Text>
          <Input value={storeData?.site_code || ""} isReadOnly mb={3} bg="gray.50" />

          <Text fontSize="sm" color="gray.500" mb={1}>Site Description</Text>
          <Input value={storeData?.site_description || ""} isReadOnly mb={3} bg="gray.50" />

          <Text fontSize="sm" color="gray.500" mb={1}>Retailer</Text>
          <Input value={storeData?.retailer || ""} isReadOnly mb={3} bg="gray.50" />

          <Text fontSize="sm" color="gray.500" mb={1}>Region</Text>
          <Select placeholder="Select Region" value={region} onChange={(e) => setRegion(e.target.value)}>
            {regions.map((r, i) => (
              <option key={i} value={r}>{r}</option>
            ))}
          </Select>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={handleSave}>Save</Button>
          <Button variant="ghost" onClick={handleClose}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddMissingStoreModal;
